import { render, staticRenderFns } from "./Societies.vue?vue&type=template&id=7ab16943&scoped=true&"
import script from "./Societies.vue?vue&type=script&lang=js&"
export * from "./Societies.vue?vue&type=script&lang=js&"
import style0 from "./Societies.vue?vue&type=style&index=0&id=7ab16943&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab16943",
  null
  
)

export default component.exports